export default __webpack_public_path__ + "static/media/csv_example_college.4fc1d95d.png";